import { useCallback, useRef, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SnackbarContext } from '../../../../state/SnackbarContextProvider';
import services from '../../../../services';

export const useUploader = ({ onUpload }: { onUpload: (url: string) => void }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { openSnackbar } = useContext(SnackbarContext);

  const uploadFile = useCallback(
    async (lernsetId: string, _file?: File) => {
      if (!_file) return;
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append('image', _file);
        const { imageUrl } = await services.lernsets.uploadImage(lernsetId, formData);

        onUpload(imageUrl);
      } catch (errPayload: any) {
        openSnackbar({
          type: 'error',
          message: t('The image could not be uploaded. Please try again.'),
        });
      }
      setLoading(false);
    },
    [onUpload],
  );

  return { loading, uploadFile };
};

export const useFileUpload = () => {
  const fileInput = useRef<HTMLInputElement>(null);

  const handleUploadClick = useCallback(() => {
    fileInput.current?.click();
  }, []);

  return { ref: fileInput, handleUploadClick };
};

